import {CompanyConvertResponse} from "../../infra/api/service/company_api_convert";
import {FrontDate} from "./frontDate";
// import {CreditCard} from "./credit_card";

// 業種
export enum Business {
    Business_Unknown = 0,
    // 農業・林業・漁業
    Business_AgricultureForestryAndFisheries = 1,
    // 鉱業
    Business_MiningIndustry = 2,
    // 建設業
    Business_ConstructionIndustry = 3,
    // 製造業
    Business_ManufacturingIndustry = 4,
    // 電気・ガス業
    Business_ElectricPowerAndGas = 5,
    // 情報通信業
    Business_InformationAndCommunicationIndustry = 6,
    // 運輸業
    Business_TransportationIndustry = 7,
    // 卸売・小売業
    Business_WholesaleAndRetailTrade = 8,
    // 飲食業
    Business_RestaurantBusiness = 9,
    // 金融・保険業
    Business_FinanceAndInsurance = 10,
    // 不動産業
    Business_RealEstateBusiness = 11,
    // サービス業
    Business_ServiceIndustry = 12,
    // 宿泊業
    Business_LodgingIndustry = 13,
    // 教育・学習支援業
    Business_EducationBusiness = 14,
    // 医療・福祉
    Business_MedicalAndWelfare = 15,
    // 学術・開発研究機関
    Business_AcademicAndResearch = 16,
    // 公務
    Business_OfficialBusiness = 17,
    // 政治・経済・文化団体
    Business_PoliticalEconomy = 18,
    // その他
    Business_OtherBusiness = 19,
}

// 従業員規模
export enum EmployeeScale {
    // (不明）
    EmployeeScale_Unknown = 0,
    // 10人以下
    EmployeeScale_Under_10_People = 1,
    // 10~100人規模
    EmployeeScale_10_100_People = 2,
    // 100~1000人規模
    EmployeeScale_100_1000_People = 3,
    // 1000人以上
    EmployeeScale_Over_1000_People = 4,
}

/** Status enum. */
export enum Status {
    Status_Unknown = 0,
    Status_Active = 1,
    Status_BAN = 2,
    Status_Demo = 3,
}

// Plan
export enum Plan {
    Plan_Unknown = 0,
    // スポット
    Plan_Spot = 1,
    // ライト
    Plan_Light = 2,
    // スタンダード
    Plan_Standard = 3,
    // プレミアム
    Plan_Premium = 4,
}

export enum PaymentMethod {
    PaymentMethod_Unknown = 0,
    PaymentMethod_Bank = 1,
}

export enum PaymentCycle {
    PaymentCycle_Unknown = 0,
    PaymentCycle_Monthly = 1,
}

// 企業
export class Company {
    public static from(from: CompanyConvertResponse): Company {
        return new Company(
            from.id,
            from.name,
            from.gsLogoURL,
            from.signedLogoURL,
            from.webURL,
            from.establishedAt,
            from.postalCode,
            from.place,
            from.business,
            from.representativeName,
            from.capitalStock,
            from.employeeScale,
            from.introduction,
            from.accordingCompanyName,
            from.accordingCompanyPostalCode,
            from.accordingCompanyAddress,
            from.invoiceDepartmentName,
            from.status,
            from.isAgreeTerms,
            // from.card,
            from.createdAt,
            from.isAdmin
        );
    }

    constructor(
        // 企業ID
        public readonly id: string,
        // 企業名
        public readonly name: string,
        // 企業ロゴ画像
        public readonly gsLogoURL: string,
        public readonly signedLogoURL: string,
        // 企業WEB　URL
        public readonly webURL: string,
        // 設立年月
        public readonly establishedAt: FrontDate,
        // 郵便番号
        public readonly postalCode: string,
        // 所在地
        public readonly place: string,
        // 業種
        public readonly business: Business[],
        // CEO名前
        public readonly representativeName: string,
        // 資本金
        public readonly capitalStock: string,
        // 従業員規模
        public readonly employeeScale: EmployeeScale,
        // 会社紹介メッセージ
        public readonly introduction: string,
        // 請求企業名
        public readonly accordingCompanyName: string,
        // 請求先郵便番号
        public readonly accordingCompanyPostalCode: string,
        // 請求先住所
        public readonly accordingCompanyAddress: string,
        // 請求部署名
        public readonly invoiceDepartmentName: string,
        // (ステータス)
        public readonly status: Status,
        public readonly isAgreeTerms: boolean,
        // public readonly card: CreditCard | null,
        // (タイムスタンプ)
        public readonly createdAt: FrontDate,
        public readonly isAdmin: boolean
    ) {
    }

    //    establishedAtがあれば"YYYY-MM-DD"形式で返してなければ""を返す
    //    originalValueが""ならば""をかえす
    public getEstablishedAtString(): string {
        const originalValue: string = this.establishedAt.originValue;
        const year: string = this.establishedAt.year;
        const month: string = this.establishedAt.month;
        const day: string = this.establishedAt.day;

        if (originalValue === "") {
            return "";
        }
        if (year === "" && month === "" && day === "") {
            return "";
        } else {
            // YYYY-MM-DD
            return `${year}-${month}-${day}`;
        }
    }

    public getStartedPlanAtString(): string {
        return "---";
    }

    public getEndedPlanAtString(): string {
        return "---";
    }

    public getCapitalStockString(): string {
        return this.capitalStock
            ? this.capitalStock.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + "円"
            : "";
    }

    public getLogoURL(): string {
        if (this.signedLogoURL) {
            return this.signedLogoURL;
        } else {
            return this.gsLogoURL;
        }
    }
}



// WEBPACK FOOTER //
// ./src/domain/model/company.ts